export default ({ store }) => {
  if (process.browser) {
    if (navigator.userAgent.match(/Android/i)) {
      store.commit('SET_DEVICE_TYPE', 'android')
    } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
      store.commit('SET_DEVICE_TYPE', 'ios')
    }
  }
}
